import { CssBaseline, ThemeProvider } from '@mui/material';
import { CustomSnackBar } from 'components/shared';
import { useSelector } from 'react-redux';
import { type RootState } from 'store';
import { RoutesConfig as Routes } from './routes';
import { ColorModeContext, useMode } from './theme';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ErrorBoundary from 'components/errorBoundary';

// Escode Escrow Verification 26th August 2025

const App = (): JSX.Element => {
  const [theme, colorMode] = useMode();
  const { isLoggedIn } = useSelector((state: RootState) => state.auth);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <CssBaseline />
          <div className="app">
            {isLoggedIn ? (
              <ErrorBoundary>
                <Routes updatePrivateRoutes={true} />
              </ErrorBoundary>
            ) : (
              <Routes updatePrivateRoutes={false} />
            )}
            <CustomSnackBar />
          </div>
        </LocalizationProvider>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};

export default App;
